<template>
  <div class="best-picks">
    <button role="button" class="best-picks__title" v-b-toggle="'best-picks-explanations'">
      <span v-html="airplane" class="best-picks__title__icon"></span>
      <span>Come calcoliamo i voli consigliati</span>
      <span v-html="chevron_down" class="best-picks__title__icon__chevron"></span>
    </button>
    <div class="best-picks__buttons">
      <best-pick
        v-for="sorting in Object.keys(sorting_options).filter((s) => !!options[s])"
        :key="sorting"
        :label="sorting_options[sorting].description"
        :description="sorting_options[sorting].info"
        :color="sorting_options[sorting].color"
        :background="sorting_options[sorting].background"
        :value="sorting"
        :duration="options[sorting].duration"
        :price="options[sorting].price"
      />
    </div>
  </div>
</template>

<script>
import BestPick from '@/components/blocks/flight-pad/best-picks/best-pick.vue';
import { sorting_options } from '@/utilities/sorting';
import { chevron_down } from '@/components/svg/chevrons';
import { airplane } from '@/components/svg/flight';

export default {
  name: 'best-picks',
  components: {
    'best-pick': BestPick,
  },
  props: {
    options: Object,
  },
  data() {
    return { sorting_options, chevron_down, airplane };
  },
};
</script>

<style lang="scss" scoped>
.best-picks {
  $this: &;

  display: flex;
  flex-direction: column;
  gap: 20px;

  &__title {
    color: $text;
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 14px;
    font-weight: 600;
    border: 0;
    background: transparent;
    width: max-content;

    & > &__icon__chevron {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      line-height: 0;
      width: 14px;
      height: 14px;
      transition: 300ms;
    }
    & > &__icon {
      margin-bottom: 5px;
      width: 20px;
      height: 20px;
    }
    * {
      fill: $text;
      stroke: $text;
      stroke-width: 1px;
    }
    @at-root #{$this}__title.not-collapsed > .best-picks__title__icon__chevron {
      transform: rotate(-180deg);
    }
  }

  &__buttons {
    display: flex;
    gap: 30px;

    width: 100%;
    overflow: hidden;
    padding: 0;
    margin-bottom: $grid-gutter-width / 2;

    @include media-breakpoint-down(md) {
      flex-direction: column;
      gap: 10px;
    }
  }
}
</style>
